@if (view == true) {
  <div [ngClass]="!viewCarousel ? 'container' : ''">
    @if (viewCarousel) {
      <app-carousel>
        <ng-template carouselItem="1">
          <ng-container *ngTemplateOutlet="matDescriptionContentTemplate"></ng-container>
        </ng-template>
        <ng-template carouselItem="2">
          <mat-card appearance="outlined" style="height: 70vh" class="mat-card-c">
            <mat-card-content class="mat-body-1">
              <h2 style="display: flex; justify-content: center">
                <strong>Recursos</strong>
              </h2>
              <app-button-label [labelsEdit]="labels"></app-button-label>
              <data-table
                [title]="''"
                [columns]="columnsResouces"
                [configuration]="configurationResouces"
                [url]="urlGetTablaResourcesRequest"
                [params]="paramsResourcesRequest"
                (internalData)="dataResources($event)"
                >
              </data-table>
            </mat-card-content>
          </mat-card>
        </ng-template>
      </app-carousel>
    } @else {
      <ng-container *ngTemplateOutlet="matDescriptionContentTemplate"></ng-container>
    }
  </div>
}

@if (!viewCarousel) {
} @else {
  @if (
    rol == 'Administrativo' || rol == 'root' || rol == 'Jefe Mantenimiento'
    ) {
    <div
      style="justify-content: space-between"
      class="button"
      >
      <button
        style="width: 45%"
        color="warn"
        class="button-save mat-elevation-z5"
        mat-raised-button
        (click)="response('rechazar')"
        >
        Rechazar
      </button>
      <button
        style="width: 45%"
        color="primary"
        class="button-save mat-elevation-z5"
        mat-raised-button
        (click)="response('autorizar')"
        >
        Autorizar
      </button>
    </div>
  }
  @if (rol == 'Operario' && view == true) {
    <div
      style="justify-content: center"
      class="button"
      >
      <button
        style="width: 60%"
        color="primary"
        class="button-save mat-elevation-z5"
        mat-raised-button
        (click)="edit('editar')"
        >
        Editar
      </button>
    </div>
  }
}
@if (view == false && action == 'editar') {
  <div>
    <mat-tab-group>
      <mat-tab label="Solicitud de Mantenimiento">
        <form
          [formGroup]="formEdit"
          (ngSubmit)="formEdit.valid ? finalizar(formEdit.value) : errorMessage()"
          >
          <div style="width: 100%; display: flex; margin: 30px 0 0 0">
            <div style="flex: 8; margin: 0 15px 0 0">
              <div class="row-item">
                <mat-form-field>
                  <mat-label>Descripción</mat-label>
                  <input
                    autocomplete="off"
                    type="text"
                    matInput
                    formControlName="description"
                    placeholder="Descripción"
                    #descripcion
                    maxlength="255"
                    />
                  <mat-hint>{{ descripcion.value?.length || 0 }}/255</mat-hint>
                </mat-form-field>
              </div>
              <div class="row-item">
                <combos
                  [dataCombos]="typeOfMaintenance"
                  [configuration]="combosTypeOfMaintenance"
                  [required]="true"
                  [reloadCombo]="reloadComboTypeOfMaintenance"
                  (changeOption)="changesTypeOfMaintenance($event)"
                  >
                </combos>
              </div>
              <div class="row-item">
                <mat-form-field [appOpenDatepickerOnClick]="pickerExecutionDate">
                  <mat-label>Fecha ejecución</mat-label>
                  <input
                    matInput
                    [matDatepicker]="pickerExecutionDate"
                    autocomplete="off"
                    formControlName="executionDate"
                    required
                    />
                  <mat-datepicker-toggle matIconSuffix [for]="pickerExecutionDate">
                  </mat-datepicker-toggle>
                  <mat-datepicker
                    #pickerExecutionDate
                    [touchUi]="movil ? true : false"
                  ></mat-datepicker>
                </mat-form-field>
              </div>
              @if (!inventoryModule) {
                <div class="row-item">
                  <mat-form-field>
                    <mat-label>Recursos</mat-label>
                    <input
                      autocomplete="off"
                      type="text"
                      formControlName="resources"
                      matInput
                      #recursos
                      maxlength="255"
                      placeholder="Recursos"
                      />
                    <mat-hint>{{ recursos.value?.length || 0 }}/255</mat-hint>
                  </mat-form-field>
                </div>
              }
            </div>
            <div style="flex: 0.2">
              <button mat-mini-fab color="warn" type="submit" [disabled]="formEdit.invalid">
                <mat-icon>save</mat-icon>
              </button>
              <button
                mat-mini-fab
                color="primary"
                (click)="back()"
                style="margin-top: 10px"
                type="button"
                >
                <mat-icon>reply</mat-icon>
              </button>
            </div>
          </div>
        </form>
      </mat-tab>
      @if (inventoryModule && resources?.length > 0) {
        <mat-tab label="Recursos">
          <div style="margin: 30px">
            <data-table
              [columns]="columnsResouces"
              [configuration]="configurationResoucesEdit"
              [reloadTable]="reloadResoucesRequest"
              [url]="urlGetTablaResourcesRequest"
              [params]="paramsResourcesRequestEdit"
              (delete)="deleteResources($event)"
              (add)="addResources($event)"
              (edit)="editResources($event)"
              (internalData)="getResourceByRequestTable($event)"
              >
            </data-table>
          </div>
        </mat-tab>
      }
    </mat-tab-group>
  </div>
}

<ng-template #matDescriptionContentTemplate>
  @if (view == true) {
    <div>
      <mat-card
        appearance="outlined"
        class="mat-card-c"
        [style]="viewCarousel ? 'height: 70vh' : ''"
        >
        <mat-card-content class="mat-body-1">
          <div class="d-flex justify-content-end">
            <div>
              @if (bodyActividad.created) {
                <h4
                  class="m-0 p-0 text-center font-weight-bold"
                  [style]="movil ? 'font-size: x-small; line-height: 0.6;' : ''"
                  >
                  Creación Solicitud
                </h4>
              }
              <h3
                class="m-0 p-0 text-center"
                [style]="movil ? 'font-size: x-small;' : ''"
                >
                {{ bodyActividad.created | dateFormat }}
              </h3>
            </div>
          </div>
          <h2 style="display: flex; justify-content: center">
            <strong>Solicitud de Mantenimiento</strong>
          </h2>
          <h3>Equipo: {{ bodyActividad.code }}</h3>
          <h3>Descripción: {{ bodyActividad.description }}</h3>
          <h3>Realización mantenimiento: {{ bodyActividad.date }}</h3>
          <h3>Tipo Mantenimiento: {{ bodyActividad.maintenanceType }}</h3>
          <h3>Solicita: {{ bodyActividad.requestName }}</h3>
          @if (!inventoryModule) {
            <h3>Recursos: {{ bodyActividad.resources }}</h3>
          }
          @if (
            rol == 'Administrativo' ||
            rol == 'root' ||
            rol == 'Jefe Mantenimiento'
            ) {
            <h3
              >
              Costo Mantenimiento: {{ bodyActividad.cost | thousandSeparator }}
            </h3>
          }
          @if (
            (rol == 'Administrativo' ||
            rol == 'root' ||
            rol == 'Jefe Mantenimiento') &&
            inventoryModule
            ) {
            <h3
              >
              Costo Recursos: {{ totalCostItems | thousandSeparator }}
            </h3>
          }
        </mat-card-content>
        @if (viewCarousel) {
          <mat-card-footer> </mat-card-footer>
        } @else {
          @if (
            rol == 'Administrativo' || rol == 'root' || rol == 'Jefe Mantenimiento'
            ) {
            <div
              style="justify-content: space-between"
              class="button"
              >
              <button
                style="width: 45%"
                color="warn"
                class="button-save mat-elevation-z5"
                mat-raised-button
                (click)="response('rechazar')"
                >
                Rechazar
              </button>
              <button
                style="width: 45%"
                color="primary"
                class="button-save mat-elevation-z5"
                mat-raised-button
                (click)="response('autorizar')"
                >
                Autorizar
              </button>
            </div>
          }
          @if (rol == 'Operario' && view == true) {
            <div
              style="justify-content: center"
              class="button"
              >
              <button
                style="width: 60%"
                color="primary"
                class="button-save mat-elevation-z5"
                mat-raised-button
                (click)="edit('editar')"
                >
                Editar
              </button>
            </div>
          }
        }
      </mat-card>
    </div>
  }
</ng-template>

